import * as ngCore from '@angular/core'
import * as router from '@attain-apps/fe/web/main/lib/router'
import * as store from '@attain-apps/fe/web/main/lib/store'

import { getActionsConfig } from './actions'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages all the current admin portal contexts, such as current tenant, zone,
 * app
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor() {
    const _router = ngCore.inject(router.Router)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'AdminContexts',
      selectors: () => new Selectors(this, _router),
    })
  }
}
